import { useRouteMatch } from "react-router-dom";
import { FlowAddPaymentMethod } from "../../Settings/components/payment/FlowAddPaymentMethod";
import { OnboardingStep } from "../types";

export const PaymentMethod: React.FC<OnboardingStep> = props => {
  const match = useRouteMatch();

  return <FlowAddPaymentMethod basePath={match.path} onNext={props.onNext} />;
};
